/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, ReactNode } from 'react'
import { IFilterArea, IFilterBarConfigs, IFilterState, IFilterStateChangeHandler } from './types'
import { EViewMode } from './view-mode.types'

export interface IDataViewState<T> {
  anchorEl: HTMLElement | null
  area?: IFilterArea
  keyword: string
  filterState: IFilterState<T>
  scrolled?: boolean
  viewMode?: EViewMode
}

export const defaultFilterBarState: IDataViewState<any> = {
  area: undefined,
  keyword: '',
  filterState: {},
  anchorEl: null
}

export type OnPanelValueChange = (anchorEl: HTMLElement | null, area?: IFilterArea) => void

export interface IDataViewContext<T = any> extends IDataViewState<T> {
  // State values
  filterBarConfigs: IFilterBarConfigs<T>

  // Action functions
  onFilterStateChange: IFilterStateChangeHandler<T>
  onKeywordChange: (keyword: string) => void
  onPopperPanelChange: OnPanelValueChange
  onPanelClose: () => void
  onClear: () => void
}

export interface IDataViewContextProps<T = any> {
  context: IDataViewContext<T>
}

export const defaultDataViewContext: IDataViewContext = {
  // State values
  filterBarConfigs: { fields: {} },
  ...defaultFilterBarState,

  // Action functions
  onFilterStateChange: () => {
    console.log('onFilterStateChange called! The context is not provider')
  },
  onKeywordChange: () => {
    console.log('setKeyword called! The context is not provider')
  },
  onPopperPanelChange: () => {
    console.log('setPanelValue called! The context is not provider')
  },
  onPanelClose: () => {
    console.log('onPanelClose called! The context is not provider')
  },
  onClear: () => {
    console.log('onClear called! The context is not provider')
  }
}

export const DataViewContext = createContext<IDataViewContext>(defaultDataViewContext)

export function mapDataViewContext<T = any>(context: (context: IDataViewContext<T>) => ReactNode): ReactNode {
  try {
    return <DataViewContext.Consumer>{context}</DataViewContext.Consumer>
  } catch (error) {
    console.log(error)
    return context(defaultDataViewContext)
  }
}
